import {kebabCase} from 'lodash-es';
import type {ISbDatasourceEntry} from '~/types/storyblok';

type DatasourceName
	= | 'tags'
	| 'preparationTime'
	| 'mealVariant'
	| 'difficulty'
	| 'sorting';

export const useStoryblokDatasourcesStore = defineStore('storyblokDatasources', () => {
	const {$storyblokApi} = useNuxtApp();
	let abort: AbortController['abort'] | null = null;

	const state = reactive<Record<DatasourceName, ISbDatasourceEntry[] | null>>({
		tags: null,
		preparationTime: null,
		mealVariant: null,
		difficulty: null,
		sorting: null,
	});

	async function _fetchAndStoreEntries(datasource: DatasourceName) {
		abort?.();
		const {signal, abort: newAbort} = abortController();
		if (import.meta.client) {
			abort = newAbort;
		}
		return (state[datasource] = await $storyblokApi.getAll('datasource_entries', {datasource: kebabCase(datasource), per_page: 200}, undefined, {signal}));
	}

	function fetchEntries(...datasources: DatasourceName[]) {
		const promises = datasources.map((dsn) => {
			const storedValue = state[dsn];

			return storedValue === null
				? _fetchAndStoreEntries(dsn)
				: Promise.resolve(storedValue);
		});

		return Promise.all(promises);
	}

	return {
		...toRefs(state),
		fetchEntries,
	};
});
